<template>
    <div class="mapview-wrapper">
        <Menu v-bind:class="{'slideout-open': menuOpen}"></Menu>
        <Locked v-if="accountLocked"></Locked>
        <div id="mapview">
            <Map></Map>
            <div class="map-button left top" @click="toggleMenu"><i class="fas fa-bars" v-if="!menuOpen"></i></div>
            <div class="map-button left bottom" @click="toggleDeviceList"><i class="fas fa-car"></i></div>
            <div class="map-icon right top has-text-danger blink_me" v-show="noConnection" :title="$t('map.connection_lost')">
        <span class="fa-stack">
          <i class="fas fa-wifi fa-stack-1x"></i>
          <i class="fas fa-slash fa-stack-1x"></i>
        </span>
            </div>
        </div>
        <Panel v-bind:class="{'panel-open': devicePanelOpen}"></Panel>
    </div>
</template>

<script>
import Map from '../components/Map';
import Menu from '../components/Menu';
import Panel from '../components/Panel';
import Locked from '../components/Locked';

export default {
    name: 'MapView',
    components: { Locked, Panel, Map, Menu },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        toggleDeviceList() {
            this.devicePanelOpen = !this.devicePanelOpen;
        }
    },
    computed: {
        menuOpen: {
            get() {
                return this.$store.state.ui.menuOpen;
            },
            set(value) {
                this.$store.commit('menuOpen', value);
            }
        },
        devicePanelOpen: {
            get() {
                return this.$store.state.ui.devicePanelOpen;
            },
            set(value) {
                this.$store.dispatch('devicePanelOpen', value);
            }
        },
        accountLocked: function() {
            return this.$store.getters.accountLocked;
        },
        noConnection: function() {
            return this.$store.state.data.noConnection;
        }
    }
};
</script>

<style scoped lang="scss">
    #mapview {
        height: 100%;
    }

    @media screen and (max-width: 500px) {
        .mapview-wrapper {
            display: flex !important;
            flex-flow: column !important;
        }

        #mapview {
            height: auto;
            position: relative;
            overflow: auto;
            flex: 2;
        }
    }

    .map-button {
        padding: 9px 15px;
        background-color: $panel-black;
        cursor: pointer;

        .fas.fa-bars {
            top: 1px;
            position: relative;
        }
    }

    .map-icon {
        padding: 0;
        font-size: 1.5em;
    }

    .map-button,
    .map-icon {
        position: fixed;
        z-index: 1500;
        color: white;

        &.left {
            left: 0;
        }

        &.right {
            right: 0;
        }

        &.top {
            top: 0;
        }

        &.bottom {
            bottom: 0;
        }
    }

    .map-button.top {
        z-index: 1700;
    }

    .blink_me {
        animation: blinker 2s linear infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }
</style>
